// extracted by mini-css-extract-plugin
module.exports = {"root":"SvgField_root__7F55G","car":"SvgField_car__3_OC4","semiTruck":"SvgField_semiTruck___HB5D"};